import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';
import { AlunosTurmasPage } from '../alunos-turmas/alunos-turmas';

@IonicPage()
@Component({
  selector: 'page-turmas',
  templateUrl: 'turmas.html',
})
export class TurmasPage {

  formModal: any = {
    id: null,
    type: 1,
    titulo: "",
    valor: null,
    limite: null,
    start: null,
    order_by: null,
    horario: "",
    descricao: ""
  }

  form: any = {
    status: "",
    type: "",
    search: "",
    page: 1,
    forpage: 10,
    date_start: "",
    date_end: ""
  }

  resultData: any = null;
  urlSearch = "/turmas";

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private service: ServiceProvider, private msgHelper: MessageHelper,
    private alertCtrl: AlertController) {
  }

  ionViewWillEnter() {
    this.search();
  }

  /**
   * Abre o modal
   */
  public new() {
    this.formModal = {
      id: null,
      type: 1,
      titulo: "",
      order_by: null,
      valor: null,
      limite: null,
      start: null,
      descricao: "",
      horario: ""
    };
    document.getElementById("modal-new-turma").classList.add("show");
  }

  /**
   * Salva a turma na API
   */
  public save() {

    if (this.formModal.titulo == "" || this.formModal.titulo == null) {
      return this.msgHelper.showToast("Você precisa informar o título da turma", "bottom", 2000);
    }
    if (this.formModal.horario == "" || this.formModal.horario == null){
      return this.msgHelper.showToast("Você precisa informar o horário da turma","bottom", 2000);
    }

    this.msgHelper.createLoading('crescent', 'Carregando...');
    this.msgHelper.showLoading();

    this.service.postData(this.formModal, "/turmas/save", false).then(result => {
      this.msgHelper.closeLoading();
      let response: any = result;
      if (response.result == 0) {
        return this.msgHelper.showAlert("Atenção!", response.message);
      }
      this.msgHelper.showAlert("Sucesso!", response.message);
      document.getElementById("modal-new-turma").classList.remove("show");
      this.search();
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Opps", error.message);
    });

  }

  /**
   * Remove o usuário do sistema
   * @param turma any
   */
  public delete(turma: any) {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja mesmo remover a turma?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({ token: turma.token }, this.urlSearch + "/delete", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * Bloquear o usuário
   * @param turma any
   */
  public block(turma: any) {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja bloquear a turma?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({ token: turma.token }, this.urlSearch +  "/block", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * Ativar o usuário
   * @param turma any
   */
  public active(turma: any) {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja bloquear a turma?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({ token: turma.token }, this.urlSearch + "/active", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  public update(obj: any) {
    this.formModal.id = obj.id;
    this.formModal.type = obj.type;
    this.formModal.titulo = obj.titulo;
    this.formModal.horario = obj.horario;
    this.formModal.descricao = obj.descricao;
    this.formModal.limite = obj.limite;
    this.formModal.order_by = obj.orderBy;
    this.formModal.valor = this.transformValor(obj.valor);
    this.formModal.start = obj.start;
    document.getElementById("modal-new-turma").classList.add("show");
  }

  public search() {
    this.form.page = 1;
    this.getData();
  }

  public backPage() {
    this.form.page = this.form.page - 1;
    this.getData();
  }

  public nextPage() {
    this.form.page = this.form.page + 1;
    this.getData();
  }

  public nextAll() {
    this.form.page = this.resultData.totalPages;
    this.getData();
  }

  public backAll()
  {
    this.search();
  }

  /**
   * Retorna os dados da API
   */
  private getData() {
    this.resultData = null;
    this.service.postData(this.form, this.urlSearch, false).then(result => {
      this.resultData = result;
      console.log(this.resultData);
      if (this.resultData.result == 0) {
        this.resultData = null;
      } else {
        this.resultData = this.resultData.data;
      }
      console.log(this.resultData);
    }, error => {
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

  transformValor(valor : number, withCurrency : boolean = false)
  {
    var numero = valor.toFixed(2).split('.');
    numero[0] =  numero[0].split(/(?=(?:...)*$)/).join('.');
    if (withCurrency){
      return "R$" + numero.join(',');
    }
    return numero.join(',');
  }

  openAlunos(turma : any)
  {
    this.navCtrl.push(AlunosTurmasPage,{
      turma: turma
    });
  }

}


// WEBPACK FOOTER //
// ./src/pages/turmas/turmas.ts